var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 100,
    viewBox: "0 0 177 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_803_3574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5175 45.2438C54.6742 44.5176 53.7808 43.973 52.8373 43.6099C51.9022 43.2468 50.9169 43.0652 49.8816 43.0652C47.8777 43.0652 46.2454 43.7154 44.9846 45.0158C43.7322 46.3162 43.106 48.0008 43.106 50.0697C43.106 52.0709 43.7155 53.7218 44.9345 55.0222C46.1619 56.3226 47.7066 56.9728 49.5685 56.9728C50.6539 56.9728 51.6851 56.7786 52.662 56.3901C53.6472 56.0017 54.5907 55.4148 55.4924 54.6295V58.0367C54.6909 58.6194 53.8184 59.0543 52.8749 59.3414C51.9314 59.6285 50.9086 59.772 49.8065 59.772C48.4037 59.772 47.1054 59.5398 45.9114 59.0754C44.7258 58.6109 43.6821 57.927 42.7804 57.0234C41.887 56.1368 41.1981 55.0939 40.7139 53.8949C40.238 52.6874 40 51.4038 40 50.0443C40 48.6848 40.238 47.4098 40.7139 46.2191C41.1981 45.0201 41.8953 43.9688 42.8054 43.0652C43.7155 42.1533 44.7592 41.4651 45.9365 41.0006C47.1138 40.5278 48.387 40.2913 49.7564 40.2913C50.8334 40.2913 51.8604 40.4518 52.8373 40.7726C53.8142 41.0851 54.7619 41.5622 55.6803 42.2039L55.5175 45.2438Z",
    fill: "url(#paint0_linear_803_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0821 51.9949H68.192L66.3134 47.7644C66.2048 47.4942 66.0921 47.186 65.9752 46.8398C65.8583 46.4851 65.7414 46.0925 65.6245 45.6618C65.5243 46.0671 65.4158 46.4471 65.2989 46.8018C65.1904 47.148 65.0776 47.4689 64.9607 47.7644L63.0821 51.9949ZM71.323 59.278L69.244 54.5028H61.98L59.8509 59.278H56.7198L65.5995 40L74.4666 59.278H71.323Z",
    fill: "url(#paint1_linear_803_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1429 55.5668L77.5225 54.4522C77.748 55.2797 78.1613 55.913 78.7624 56.3521C79.3636 56.7828 80.1317 56.9981 81.0669 56.9981C81.9519 56.9981 82.6533 56.749 83.1709 56.2508C83.697 55.7526 83.96 55.0855 83.96 54.2495C83.96 53.1602 83.0666 52.1891 81.2798 51.3363C81.0293 51.2096 80.8373 51.1167 80.7037 51.0576C78.6831 50.0612 77.3347 49.1619 76.6584 48.3597C75.9904 47.5491 75.6564 46.5611 75.6564 45.3958C75.6564 43.8843 76.1616 42.6599 77.1719 41.7226C78.1905 40.7853 79.5222 40.3167 81.1671 40.3167C82.5197 40.3167 83.651 40.5826 84.5611 41.1146C85.4712 41.6382 86.1016 42.3939 86.4523 43.3819L84.1228 44.5978C83.7554 44.0152 83.3505 43.5888 82.9079 43.3186C82.4738 43.0483 81.9728 42.9132 81.405 42.9132C80.6035 42.9132 79.9648 43.1243 79.4888 43.5465C79.0213 43.9688 78.7875 44.5345 78.7875 45.2438C78.7875 46.3585 79.8228 47.3971 81.8935 48.3597C82.0521 48.4357 82.1774 48.4948 82.2692 48.537C84.081 49.3815 85.3251 50.209 86.0014 51.0196C86.6777 51.8218 87.0159 52.8267 87.0159 54.0342C87.0159 55.7906 86.469 57.1881 85.3752 58.2267C84.2814 59.2569 82.8036 59.772 80.9416 59.772C79.3803 59.772 78.0986 59.4089 77.0967 58.6827C76.1031 57.9565 75.4519 56.9179 75.1429 55.5668Z",
    fill: "url(#paint2_linear_803_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3223 59.278V40.7346H93.303V59.278H90.3223Z",
    fill: "url(#paint3_linear_803_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5863 59.278V40L109.234 51.3363C109.551 51.6572 109.873 51.9992 110.198 52.3623C110.524 52.7254 110.866 53.1349 111.225 53.5909V40.7346H113.98V60L102.095 48.4611C101.778 48.1486 101.469 47.8193 101.168 47.4731C100.876 47.1269 100.596 46.7638 100.329 46.3838V59.278H97.5863Z",
    fill: "url(#paint4_linear_803_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.894 50.0443C133.894 49.107 133.723 48.2162 133.381 47.3718C133.047 46.5273 132.562 45.7758 131.928 45.1172C131.31 44.467 130.592 43.9688 129.774 43.6225C128.964 43.2679 128.108 43.0906 127.206 43.0906C126.304 43.0906 125.444 43.2637 124.626 43.6099C123.816 43.9561 123.094 44.4585 122.459 45.1172C121.825 45.7674 121.341 46.5147 121.007 47.3591C120.673 48.2035 120.506 49.0986 120.506 50.0443C120.506 50.9816 120.673 51.8683 121.007 52.7042C121.341 53.5402 121.825 54.2875 122.459 54.9462C123.094 55.6048 123.816 56.1072 124.626 56.4535C125.436 56.7997 126.296 56.9728 127.206 56.9728C128.099 56.9728 128.947 56.7997 129.748 56.4535C130.558 56.1072 131.285 55.6048 131.928 54.9462C132.562 54.2875 133.047 53.5402 133.381 52.7042C133.723 51.8598 133.894 50.9732 133.894 50.0443ZM137 50.0443C137 51.3616 136.754 52.6071 136.261 53.7809C135.777 54.9546 135.067 56.0017 134.132 56.9221C133.188 57.8425 132.124 58.5476 130.938 59.0374C129.753 59.5271 128.509 59.772 127.206 59.772C125.887 59.772 124.626 59.5271 123.424 59.0374C122.23 58.5392 121.174 57.8341 120.255 56.9221C119.32 56.0017 118.61 54.9588 118.126 53.7935C117.642 52.6282 117.4 51.3785 117.4 50.0443C117.4 48.7186 117.642 47.4689 118.126 46.2951C118.61 45.1214 119.32 44.0701 120.255 43.1412C121.19 42.2208 122.251 41.5199 123.436 41.0386C124.622 40.5573 125.879 40.3167 127.206 40.3167C128.525 40.3167 129.774 40.5573 130.951 41.0386C132.136 41.5199 133.197 42.2208 134.132 43.1412C135.067 44.0785 135.777 45.1383 136.261 46.3205C136.754 47.4942 137 48.7355 137 50.0443Z",
    fill: "url(#paint5_linear_803_3574)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_803_3574",
    x: 0,
    y: 0,
    width: 177,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.6 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_803_3574"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_803_3574",
    result: "effect2_dropShadow_803_3574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_803_3574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_803_3574",
    x1: 88.5,
    y1: 40,
    x2: 88.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583233,
    stopColor: "#FFD898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FFC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.5232498746b8c4345392b92fce881352.svg";
export { ForwardRef as ReactComponent };